import { PureComponent } from 'react'
import styled from 'glamorous'
import { withRouter } from 'react-router-dom'
import { map } from 'lodash'

import { $ } from 'utils'
import { Button, ImagePure, InertialScrolling, Date } from 'components'


const Container = styled.div({
  width: '185px',
  marginLeft:'10px',
  '&:first-child': {
    marginLeft: 0,
  },
  '&:hover .desc-container': {
    boxShadow: '0px 5px 15px 0 rgba(189, 189, 189, 0.3)'
  },
  '&:hover .desc-container .desc-bottom': {
    display: 'block',
  },
})

const Header = styled.div({
  height: 35,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: 19,
})

const Avatar = styled.div({
  position: 'relative'
})

const ContainerNumbers = styled.div({
  position: 'absolute',
  width: '100%',
  bottom:0,
  display: 'flex',
  justifyContent: 'space-between',
})

const NumberContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '50px',
  height: '50px',
  backgroundColor: 'var(--darkGrey)',
  fontSize: 19,
  color: 'var(--white)'
}, ({ isGood }) => isGood && ({
  backgroundColor: 'var(--green)',
}))

const DescriptionContainer = styled.div({
  width: '100%',
}, 'desc-container')

const TopBlock = styled.div({
  width: '100%',
  padding: '22px 18px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  boxSizing: 'border-box',
})

const Data = styled.div({
  fontWeight: 900,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word'
})

const Id = styled.div({
  marginTop: 10,
  whiteSpace: 'pre-wrap',
  textAlign: 'center'
})

const BottomBlock = styled.div({
  display: 'none',
  width: '100%',
  padding: '22px 24px',
  borderTop: 'var(--border)',
  boxSizing: 'border-box',
}, 'desc-bottom')

const DateInfo = styled.div({
  marginTop: 15,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

const Info = styled.div({
  color: 'var(--grey)',
  whiteSpace: 'pre-wrap'
}, ({ fontSize }) => ({ fontSize }))

const PhotoContainer = styled.div({
  flex: 1,
  overflow: 'hidden',
  height: 50,
  marginTop: 10,
})

const PhotoInnerContainer = styled.div({
  display: 'flex',
  height: '100%',
  overflow: 'auto',
  cursor: 'pointer'
})

const MinPhoto = styled.div({
  marginRight: 5,
  '& img': {
    userDrag: 'none',
    WebkitUserDrag: 'none'
  }
})


class MatchDetails extends PureComponent {

  openFace = (descriptor) => {
    this.props.history.push(`/faces/${descriptor.uuid}`)
  }

  openPerson = (person) => {
    this.props.history.push(`/persons/${person.uuid}`)
  }

  render = () => {
    const { matchResult: { descriptor, person, similarity }, listKey, matchType } = this.props
    const isMatch = matchType === 'match'
    const result = isMatch ? descriptor : person
    const matchPerson = isMatch ? descriptor.person : person

    return (
      $(Container,
        $(Header, (similarity * 100).toFixed(2) + '%'),
        $(Avatar,
          result.portrait &&
            $(ImagePure, {
              src: result.portrait,
              width: 185,
              height: 240
            }),
          $(ContainerNumbers,
            $(NumberContainer, { isGood: similarity > 0.8 }, listKey + 1),
            !!matchPerson &&
              $(ImagePure, {
                src: matchPerson.portrait,
                width: 40,
                height: 50
              })
          )
        ),
        !isMatch &&
          $(PhotoContainer,
            $(PhotoInnerContainer,
              $(InertialScrolling,
                map(person.descriptors, (val, key) =>
                  $(MinPhoto, { key },
                    $(ImagePure, {
                      src: val.portrait,
                      width: 38,
                      height: 50
                    })
                  )
                )
              ),
            ),
          ),
        $(DescriptionContainer,
          $(TopBlock,
            $(Data, isMatch ? '' : person.userData),
            $(Id, isMatch ? descriptor.uuid : person.uuid),
          ),
          $(BottomBlock,
            $(Button, {
              bgColor: 'var(--violet)',
              width: '100%',
              primary: true,
              onClick: isMatch ? () => this.openFace(descriptor) : () => this.openPerson(person)
            },
              isMatch && 'Open in Faces',
              !isMatch && 'Open in Persons',
            ),
            descriptor &&
              $(DateInfo,
                $(Info, 'Last update'),
                $(Info, { fontSize: 13 }, $(Date, { value: descriptor.lastUpdate }))
              ),
            person &&
              $(DateInfo,
                $(Info, 'Create time'),
                $(Info, $(Date, { value: person.createTime }))
              )
          )
        )
      )
    )
  }
}

export default withRouter(MatchDetails)


// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/MatchDetails.js